import { render, staticRenderFns } from "./modalQrCode.vue?vue&type=template&id=4b56ed6f&scoped=true"
import script from "./modalQrCode.vue?vue&type=script&lang=js"
export * from "./modalQrCode.vue?vue&type=script&lang=js"
import style0 from "./modalQrCode.vue?vue&type=style&index=0&id=4b56ed6f&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4b56ed6f",
  null
  
)

export default component.exports